import { render, staticRenderFns } from "./AdminApplicants.vue?vue&type=template&id=7572e126&scoped=true&"
import script from "./AdminApplicants.vue?vue&type=script&lang=js&"
export * from "./AdminApplicants.vue?vue&type=script&lang=js&"
import style0 from "./AdminApplicants.vue?vue&type=style&index=0&id=7572e126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572e126",
  null
  
)

component.options.__file = "AdminApplicants.vue"
export default component.exports